import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFriendlyMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.5 -0.0215626C3.375 -0.0215626 0 2.88469 0 6.54094C0 10.1972 3.375 13.1034 7.5 13.1034C7.84649 13.1233 8.19401 13.0917 8.53125 13.0097L13.125 14.9784V10.8534C13.7071 10.2943 14.1726 9.62523 14.4945 8.88499C14.8163 8.14475 14.9881 7.34803 15 6.54094C15 2.88469 11.625 -0.0215626 7.5 -0.0215626ZM10.2572 7.15594L7.5 9.88031L4.74281 7.15594L4.72312 7.13625C4.56153 6.97208 4.43386 6.77769 4.34739 6.56418C4.26092 6.35066 4.21736 6.12221 4.21919 5.89186C4.22102 5.66151 4.2682 5.43378 4.35804 5.22166C4.44789 5.00955 4.57863 4.81721 4.74281 4.65562C4.8209 4.57922 4.90561 4.50988 4.99594 4.44844C5.19193 4.31557 5.41217 4.22262 5.64409 4.17488C5.87601 4.12714 6.11506 4.12556 6.34759 4.17022C6.58012 4.21488 6.80158 4.30491 6.99931 4.43517C7.19704 4.56542 7.36718 4.73336 7.5 4.92937C7.56114 4.83966 7.63017 4.75558 7.70625 4.67812C8.04165 4.33707 8.49874 4.14312 8.97706 4.1389C9.45539 4.13468 9.91582 4.32054 10.2572 4.65562L10.2769 4.67625C10.4384 4.84034 10.5661 5.03465 10.6525 5.24809C10.739 5.46152 10.7826 5.6899 10.7807 5.92017C10.7789 6.15044 10.7317 6.3781 10.6419 6.59014C10.5521 6.80217 10.4213 6.99443 10.2572 7.15594Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconFriendlyMessage;
